import { size } from '@/shared/filters';

export const documentsFields = [
  'commands',
  'preview',
  'filename',
  'type',
  {
    key: 'size',
    formatter: size,
  },
];
